import { EventEmitter, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";

@Injectable({
    providedIn: 'root',
})
export class FareOptimisationNavigationService {

    public navigationEvent: EventEmitter<string> = new EventEmitter<string>();

    constructor(
        private readonly location: Location,
    ) {
    }

    /**
     * Manage url change with offerId and emit offerId listend in fare-optimisation Card
     * @param offerId
     * @param router
     * @param activatedRoute
     */
    public updateUrlWithOfferId(offerId: string, router: Router, activatedRoute: ActivatedRoute): void {
        if (offerId) {
            const currentOfferId: string = activatedRoute.snapshot.params.offerId;
            const currentUrl: string = router.url;
            if (currentOfferId) {
                const newUrl: string = currentUrl
                    .split(`/${currentOfferId}`)
                    .join(`/${offerId}`);
                this.location.go(newUrl);
                this.navigationEvent.emit(offerId);
            }else{
                const urlBegin: string = currentUrl.split('#')[0];
                const newUrl: string = `${urlBegin}/${offerId}#fareOptimisation`;
                this.location.go(newUrl);
                this.navigationEvent.emit(offerId);
            }
        }
    }
}
